import { useEffect } from "react";


export const SUPPORT_ROBOTS = "noindex,nofollow,noarchive,nosnippet";

export function useSupportRobotsMetadata() {
  useEffect(() => {
    const existing = document.querySelector<HTMLMetaElement>('meta[name="robots"]');
    const previousContent = existing?.getAttribute("content") ?? null;
    const meta = existing ?? document.createElement("meta");
    if (!existing) {
      meta.setAttribute("name", "robots");
      document.head.appendChild(meta);
    }
    meta.setAttribute("content", SUPPORT_ROBOTS);

    return () => {
      if (existing) {
        if (previousContent === null) existing.removeAttribute("content");
        else existing.setAttribute("content", previousContent);
      } else {
        meta.remove();
      }
    };
  }, []);
}
